import AssistantScenariosAPI from 'dashboard/api/assistant/scenarios';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'AssistantScenario',
  API: AssistantScenariosAPI,
  actions: mutations => ({
    update: async ({ commit }, { id, agentId, ...updateObj }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await AssistantScenariosAPI.update(
          { id, agentId },
          updateObj
        );
        commit(mutations.EDIT, response.data);
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return throwErrorMessage(error);
      }
    },

    delete: async ({ commit }, { id, agentId }) => {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await AssistantScenariosAPI.delete({ id, agentId });
        commit(mutations.DELETE, id);
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return id;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
